export default __webpack_public_path__ + "static/media/cta-button-bg.8f0b5653.svg";